import { useMutation, useQuery } from '@apollo/client/react';
import { REJECT_ORDER, GET_REJECTION_REASONS } from 'api/graphql/orders';
import env from 'config/env';

/** Loads the list of rejection reasons for the reject dialog. */
export function useRejectionReasons() {
  const { data, loading } = useQuery(GET_REJECTION_REASONS, {
    variables: { languageCode: env.defaultLanguage },
    errorPolicy: 'all',
  });
  return { reasons: data?.getRejectionReasons ?? [], loading };
}

/** Rejects a single order item with a reason. */
export function useRejectOrder() {
  const [mutate, { loading }] = useMutation(REJECT_ORDER);

  const rejectOrder = async ({ orderItemId, reason }) => {
    const { data } = await mutate({ variables: { orderItemId, reason } });
    return data?.rejectOrder ?? null;
  };

  return { rejectOrder, loading };
}
